import { SelectField } from '~/shared/forms/controls/base-fields/SelectField';
import { AutocompleteSearchField } from '~/shared/forms/controls/base-fields/AutocompleteSearchField';
import { DatePickerField } from '~/shared/forms/controls/base-fields/DatePickerField';
import { useQueryDataTableFilter } from '~/shared/data-tables/query/useQueryDataTableFilter';
import { useSuspenseQuery } from '@tanstack/react-query';
import { getCareportTeamsOptions } from '@generated';
import { convertClientDateToServerDate, convertUrlDateToClientDate } from '~/util/date';

export function PatientFilter() {
	const [sponsorMrn, setSponsorMrn] = useQueryDataTableFilter<string>({
		name: 'sponsorMrn'
	});

	return (
		<AutocompleteSearchField
			label="Patient"
			hideLabel
			placeholder="All Patients"
			searchType="legacy-patients"
			value={sponsorMrn}
			onChange={id => setSponsorMrn(id)}
		/>
	);
}

export function FacilityFilter() {
	const [facilityNpi, setFacilityNpi] = useQueryDataTableFilter<string>({
		name: 'facilityNpi'
	});

	return (
		<AutocompleteSearchField
			label="Facility"
			hideLabel
			placeholder="All Facilities"
			searchType="careport-facility"
			value={facilityNpi}
			className="min-w-[300px]"
			onChange={id => setFacilityNpi(id)}
		/>
	);
}

export function TeamFilter() {
	const { data: options } = useSuspenseQuery(getCareportTeamsOptions());
	const [team, setTeam] = useQueryDataTableFilter({
		name: 'patientTeam'
	});
	return <SelectField label="Team" hideLabel placeholder="All Teams" value={team} onChange={id => setTeam(id)} items={options} />;
}

export function StayStartedOnFilter() {
	const [firstStatusDate, setFirstStatusDate] = useQueryDataTableFilter({
		name: 'firstStatusDate',
		convertFromQueryParam: value => convertUrlDateToClientDate(value),
		convertToQueryParam: value => convertClientDateToServerDate(value),
		operator: '>='
	});
	return <DatePickerField label="Stay Started On" hideLabel required value={firstStatusDate} onChange={setFirstStatusDate} />;
}

export function LastStatusReceivedAsOfFilter() {
	const [statusDateTime, setStatusDateTime] = useQueryDataTableFilter({
		name: 'statusDate',
		convertFromQueryParam: value => convertUrlDateToClientDate(value),
		convertToQueryParam: value => convertClientDateToServerDate(value),
		operator: '>='
	});
	return <DatePickerField label="Status Date" hideLabel required value={statusDateTime} onChange={setStatusDateTime} />;
}
